import React, { useState } from 'react';
import { CalcCard, CalcField, ResultStat, GrowthChart, CalcFooter, formatINR } from './shared';

const simulate = (amount, withdrawal, rate, years) => {
  const r = rate / 12 / 100;
  let balance = amount;
  let withdrawn = 0;
  let monthsLasted = null;
  const data = [];
  for (let m = 1; m <= years * 12; m += 1) {
    balance *= 1 + r;
    const w = Math.min(withdrawal, balance);
    balance -= w;
    withdrawn += w;
    if (balance <= 0 && monthsLasted === null) monthsLasted = m;
    if (m % 12 === 0) data.push({ label: `Yr ${m / 12}`, balance, withdrawn });
  }
  return { data, balance, withdrawn, monthsLasted };
};

export const SwpCalculator = () => {
  const [amount, setAmount] = useState(2000000);
  const [withdrawal, setWithdrawal] = useState(15000);
  const [rate, setRate] = useState(8);
  const [years, setYears] = useState(15);

  const { data, balance, withdrawn, monthsLasted } = simulate(amount, withdrawal, rate, Math.max(1, Math.round(years)));

  return (
    <CalcCard title="SWP Calculator" subtitle="See how regular monthly withdrawals may affect your investment over time." testId="swp-calculator">
      <div className="space-y-6 mb-8">
        <CalcField label="Total Investment (₹)" value={amount} onChange={setAmount} min={100000} max={50000000} step={50000} testId="swp-amount" />
        <CalcField label="Monthly Withdrawal (₹)" value={withdrawal} onChange={setWithdrawal} min={1000} max={500000} step={1000} testId="swp-withdrawal" />
        <CalcField label="Assumed Annual Return (%) – illustrative" value={rate} onChange={setRate} min={1} max={15} step={0.5} testId="swp-returns" />
        <CalcField label="Withdrawal Period (Years)" value={years} onChange={setYears} min={1} max={40} testId="swp-years" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
        <ResultStat label="Total Investment" value={formatINR(amount)} testId="swp-invested-result" />
        <ResultStat label="Total Withdrawn" value={formatINR(withdrawn)} testId="swp-withdrawn-result" accent />
        <ResultStat label="Illustrative Final Balance" value={formatINR(balance)} testId="swp-balance-result" />
      </div>
      {monthsLasted && (
        <p className="text-sm font-body text-[#A0451E] bg-white border border-[#D97706]/40 rounded-lg px-4 py-3 mb-4" data-testid="swp-depleted-warning">
          At these assumptions, the investment would run out after about {Math.floor(monthsLasted / 12)} years and {monthsLasted % 12} months.
        </p>
      )}
      <GrowthChart
        data={data}
        series={[
          { key: 'balance', name: 'Remaining Balance', color: '#D97706' },
          { key: 'withdrawn', name: 'Total Withdrawn', color: '#A0451E' },
        ]}
        testId="swp-chart"
      />
      <CalcFooter testId="swp" />
    </CalcCard>
  );
};
